import {
  Icon,
  Button,
  OverlayToaster,
  Position,
  Intent
} from "@blueprintjs/core";
import axios from "axios";
import React, { useState } from "react";
import { APIURL } from "../../config";
import { useNavigate, useLocation } from "react-router-dom";

export function SaveContinue(editor) {
  const navigate = useNavigate();
  const location = useLocation();
  const [saveloader, setsaveloader] = useState(false);
  const {
    createID, 
    updateID, 
    canvases, 
    canvasObjects 
  } = editor;

  const safeEncodeURIComponent = (input) => {
    try {
      return encodeURIComponent(input);
    } catch (error) {
      console.error("Encoding failed:", error.message);
      return input;
    }
  };
  // Save & Download.
  const saveTemplate = () => {

    setsaveloader(true);
    let allPagesObjects = [];
    const save_api = `${APIURL}/api/v1/save`;
    
    if (canvasObjects.length > 0 ){
      // Set canvas object for all pages.
      canvasObjects.forEach((allPageObjects, pageIndex) => {
        
        canvases[pageIndex].discardActiveObject();
        canvases[pageIndex].renderAll();
        
        const canvasImg =
          canvases[pageIndex]
            ? canvases[pageIndex].toDataURL("image/png")
            : "";
        const canvasObj = canvases[pageIndex]
          ? safeEncodeURIComponent(
              JSON.stringify(canvases[pageIndex].toDatalessJSON(["customType"]))
            )
          : "";
        const pagesObjects = {
          page_id: allPageObjects.page_id,
          page_order: allPageObjects.page_order,
          jasondata: canvasObj,
          template_id: updateID || createID,
          images: canvasImg,
        };
        allPagesObjects.push(pagesObjects);
      });

      if (createID) {
        axios
          .post(save_api, {
            page_details: allPagesObjects,
          })
          .then(function (response) {
            setsaveloader(false);
            if (response.data.msg) {
              OverlayToaster.create({
                position: Position.TOP_RIGHT,
                maxToasts: 1,
                autoFocus: false,
                canEscapeKeyClear: true,
              }).show({
                message: "Template Saved",
                intent: Intent.SUCCESS,
                icon: "tick",
                timeout: 3000,
              });

              setTimeout(function () {
                  // Replace "create" with "update" in the current path
                  const updatedPath = location.pathname.replace(
                    /create$/,
                    "update"
                  );

                  // Navigate to updated URL and reload
                  navigate(updatedPath, { replace: true });
                  window.location.reload(); // Forces reload of the current page
                  // window.location.href = `${APIURL}/templates`;
              }, 2000);
            } else {
              // alert(response.data.error);
              OverlayToaster.create({
                position: Position.TOP_RIGHT,
                maxToasts: 1,
                autoFocus: false,
                canEscapeKeyClear: true,
              }).show({
                message: response.data.error,
                intent: Intent.DANGER,
                icon: "error",
                timeout: 3000,
              });
            }
          })
          .catch(function (error) {
            setsaveloader(false);
            console.log(error);
            OverlayToaster.create({
              position: Position.TOP_RIGHT,
              maxToasts: 1,
              autoFocus: false,
              canEscapeKeyClear: true,
            }).show({
              message: "Oops!something went wrong during save.",
              intent: Intent.DANGER,
              icon: "error",
              timeout: 3000,
            });
          });
      } else {
        axios
          .put(save_api, {
            page_details: allPagesObjects,
          })
          .then(function (response) {
            setsaveloader(false);
            if (response.data.msg) {
              // window.location.href = `${APIURL}/templates`;
              OverlayToaster.create({
                position: Position.TOP_RIGHT,
                maxToasts: 1,
                autoFocus: false,
                canEscapeKeyClear: true,
              }).show({
                message: "Template Saved",
                intent: Intent.SUCCESS,
                icon: "tick",
                timeout: 3000,
              });
            } else {
              OverlayToaster.create({
                position: Position.TOP_RIGHT,
                maxToasts: 1,
                autoFocus: false,
                canEscapeKeyClear: true,
              }).show({
                message: response.data.error,
                intent: Intent.DANGER,
                icon: "error",
                timeout: 3000,
              });
              // alert(response.data.error);
            }
          })
          .catch(function (error) {
            setsaveloader(false);
            console.log(error);
            OverlayToaster.create({
              position: Position.TOP_RIGHT,
              maxToasts: 1,
              autoFocus: false,
              canEscapeKeyClear: true,
            }).show({
              message: "Oops!something went wrong during save.",
              intent: Intent.DANGER,
              icon: "error",
              timeout: 3000,
            });
            // alert("Oops!something went wrong during save.");
          });
      }
    }

  };
  return (
    <div className="bp4-navbar-group bp4-align-right">
      {saveloader && <Button icon={<Icon icon="saved" />} text="Loading..." />}
      {!saveloader && (
        <Button
          onClick={saveTemplate}
          icon={<Icon icon="saved" />}
          text="Save"
        />
      )}
    </div>
  );
}
